export const TOTAL_SCOPE = `#/properties/total/properties`
export const TOTAL_KEY = `total`

// pie, donut
export const TOTAL_PIE_OPTION_KEY = `options.plotOptions.pie.donut.labels`
export const TOTAL_PIE_FORMATTER_KEY = `options.plotOptions.pie.donut.labels`
